module.exports = __webpack_public_path__ + "assets/img/two-tab3-on.c75521d6.png";